function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20 9V6h-3V4h3c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v3h-2zM2 9V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 014 4h3v2H4v3H2zm15 11v-2h3v-3h2v3c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0120 20h-3zM4 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 012 18v-3h2v3h3v2H4zm2-4V8h12v8H6zm2-2h8v-4H8v4z"
})));